import { IApplicationState } from 'shared/types/redux';

export const selectFinancePlatformEnabled = (state: IApplicationState) => state.landing.financePlatformEnabled;
